import { useEffect } from 'react';
import _isEqual from 'lodash/isEqual';
import { sendClick } from 'reaxl-analytics';
import { ndsAutoFill } from 'reaxl-analytics-handlers';
const useUDSAutoFillData = _ref => {
  let {
    updateMyWalletInteractions,
    isAutoFilled,
    setIsAutoFilled,
    isLoading,
    creditType,
    downPaymentValue,
    dueAtSigningValue,
    paymentsInfo,
    paymentsDuck,
    leasePayment,
    udsLocalStateValues
  } = _ref;
  const {
    listingId,
    financeDownPayment,
    offerPrice,
    localPrice,
    activeTab,
    financeOffersObj,
    selectedLeaseTerm,
    localTradeInValue,
    localAmountOwed,
    financeDownPaymentPercentageValue,
    selectedLoanTerm
  } = udsLocalStateValues;
  const {
    budget,
    monthlyBudget,
    interactions
  } = paymentsInfo || {};
  const {
    hasOpenedWallet = false,
    hasWalletInteractionWithinVDP = false,
    autoFilledListing = []
  } = interactions || {};
  const prevAutoFillData = autoFilledListing.length === 0 ? {} : {
    ...autoFilledListing[listingId]
  };
  useEffect(() => {
    const currentAutoFillData = {
      creditType,
      loanTerm: selectedLoanTerm?.toString(),
      leaseTerm: selectedLeaseTerm?.toString(),
      budget,
      monthlyBudget,
      tradeInValue: localTradeInValue,
      amountOwed: localAmountOwed,
      downPaymentPercentValue: financeDownPaymentPercentageValue,
      downPaymentValue,
      dueAtSigningValue
    };
    const hasAutoFillData = localAmountOwed || localTradeInValue || financeDownPayment || dueAtSigningValue;
    const matchAutofillData = _isEqual(currentAutoFillData, prevAutoFillData);
    if (!isLoading && hasOpenedWallet && hasAutoFillData && !matchAutofillData && !isAutoFilled && !hasWalletInteractionWithinVDP) {
      sendClick(ndsAutoFill, null, {
        listingId,
        walletData: {
          paymentsInfo,
          price: localPrice,
          offerPrice
        },
        paymentsDuck,
        activeTab,
        financePayment: financeOffersObj?.payment,
        leasePayment,
        downPayment: paymentsInfo?.downPayment
      });
      setIsAutoFilled(true);
      updateMyWalletInteractions({
        autoFilledListing: {
          ...autoFilledListing,
          [listingId]: currentAutoFillData
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendClick, listingId, isLoading, localAmountOwed, localTradeInValue, financeDownPayment, dueAtSigningValue, isAutoFilled]);
};
export { useUDSAutoFillData as default };
